<div class="consent-screen-main-container text">
  <div class="header-container">{{ 'b3000_Consent_checkbox_text_8' | t }} {{ this._UserHelper.customerUser?.CustomerName }}</div>
  <div class="info-container">
    {{ 'b3000_Consent_checkbox_text_3' | t }}
  </div>

  <form [formGroup]="consentScreenForm">
    <div class="checkbox-container">
      <!-- I have read and accepted the Terms and Conditions. -->
      <div class="checkbox-container-item">
        <input class="checkbox_with_label" type="checkbox" id="terms_conditions" name="terms_conditions" required="{{ 'Required' | t }}" formControlName="terms_conditions" />
        <span class="input-span">
          <label for="terms_conditions">
            {{ 'b3000_Consent_checkbox_text_1' | t }}
            <a class="item2" routerLink="/article/{{ 'route_article_footer_5' | t }}" target="_blank">{{ 'b3000_Consent_checkbox_text_S1' | t }}</a>

            {{ 'b3000_Consent_checkbox_text_S2' | t }}
          </label>
        </span>
      </div>
      <div class="checkbox-container-item">
        <input class="checkbox_with_label" type="checkbox" id="privacy" name="privacy" required="{{ 'Required' | t }}" formControlName="privacy" />

        <span class="input-span">
          <label for="privacy">
            {{ 'b3000_Consent_checkbox_text_2_1' | t }}
            <a class="item2" routerLink="/article/{{ 'route_article_footer_4' | t }}" target="_blank">{{ 'b3000_Consent_checkbox_text_2_2' | t }}</a
            >{{ 'b3000_Consent_checkbox_text_2_3' | t }}

            <!--
    <a
    class="item2"
    routerLink="/article/{{ 'route_article_footer_4' | t }}" target="_blank"

    >{{ 'b3000_Consent_checkbox_text_2S' | t }}</a
  >

    {{ 'b3000_Consent_checkbox_text_3S' | t }} -->
          </label>
        </span>
      </div>
    </div>
    <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
      <div *ngSwitchCase="'wettarena'" class="footer-container">
        <span>
          {{ 'b3000_Consent_checkbox_text_7_1' | t }}
          <a
            href="mailto:{{ 'supportMail' | getEnv }}?Subject=Pay3000/{{ this.pay3000Customer?.Data?.customerAccountNumber }}/{{ this._UserHelper?.customerUser?.UserName }}"
            style="text-decoration: underline; color: #212529; font-weight: 800; margin-left: 5px">
            {{ 'supportMail' | getEnv }}
          </a>
          {{ 'b3000_Consent_checkbox_text_7_3' | t }}
        </span>
      </div>
      <div *ngSwitchCase="'b500'" class="footer-container">
        <span>
          {{ 'b3000_Consent_checkbox_text_7_1' | t }}
          <a
            href="mailto:{{ 'supportMail' | getEnv }}?Subject=Pay3000/{{ this.pay3000Customer?.Data?.customerAccountNumber }}/{{ this._UserHelper?.customerUser?.UserName }}"
            style="text-decoration: underline; color: #212529; font-weight: 800; margin-left: 5px">
            {{ 'supportMail' | getEnv }}
          </a>
          {{ 'b3000_Consent_checkbox_text_7_3' | t }}
        </span>
      </div>
      <div *ngSwitchDefault class="footer-container">
        <span>
          {{ 'b3000_Consent_checkbox_text_7_1' | t }}
          <a
            href="mailto:{{ 'supportMail' | getEnv }}?Subject=Pay3000/{{ this.pay3000Customer?.Data?.customerAccountNumber }}/{{ this._UserHelper?.customerUser?.UserName }}"
            style="text-decoration: underline; color: #212529; font-weight: 800; margin-left: 5px">
            {{ 'supportMail' | getEnv }}
          </a>
          {{ 'b3000_Consent_checkbox_text_7_3' | t }}
        </span>
      </div>
    </ng-container>
    <div class="submit-wrap">
      <button [disabled]="!this.consentScreenForm.valid" type="submit" id="submitBtn" class="buttonSuccess" (click)="acceptConsent()">
        {{ 'Confirm' | t }}
      </button>
    </div>
  </form>
</div>
